import React from "react";
import classes from "./RiskDisclosurePage.module.css";
import clsx from "clsx";
import { Heading, SectionHeading, Text } from "components/common";
import { FaUserPlus, FaBitcoin, FaChartLine, FaShieldAlt, FaHeadset, FaUserTie } from "react-icons/fa";

const HowToStartPage = ({ frontendInfo }) => {
    return (
        <section className={classes.wrapper}>
            <div className={clsx(classes.container, "container")}>
                {/* Header Section */}
                <div className={classes.header}>
                    {/* <SectionHeading>GET STARTED</SectionHeading> */}
                    <Heading xl6 primitive950 className={classes.heading}>
                        Begin Your Investment Journey in 3 Simple Steps
                    </Heading>
                    <Text primitive800 xl className={classes.info}>
                        Start your investment journey with {frontendInfo?.site_name} today. Follow these straightforward steps to begin growing your portfolio.
                    </Text>
                </div>

                {/* Main Steps Section */}
                <div className={classes.stepsContainer}>
                    {/* Step 1 */}
                    <div className={classes.stepCard}>
                        <div className={classes.stepNumber}>1</div>
                        <div className={classes.stepIcon}>
                            <FaUserPlus size={32} />
                        </div>
                        <div className={classes.stepContent}>
                            <Heading xl5 primitive950 className={classes.stepTitle}>
                                Create Your Account
                            </Heading>
                            <Text primitive800 lg className={classes.stepText}>
                                Sign up with {frontendInfo?.site_name} by providing your details. Verify your email to proceed to the next step.
                            </Text>
                        </div>
                    </div>

                    {/* Step 2 */}
                    <div className={classes.stepCard}>
                        <div className={classes.stepNumber}>2</div>
                        <div className={classes.stepIcon}>
                            <FaBitcoin size={32} />
                        </div>
                        <div className={classes.stepContent}>
                            <Heading xl5 primitive950 className={classes.stepTitle}>
                                Fund with Bitcoin
                            </Heading>
                            <Text primitive800 lg className={classes.stepText}>
                                Add funds to your account using Bitcoin. Choose an investment plan that aligns with your financial goals.
                            </Text>
                        </div>
                    </div>

                    {/* Step 3 */}
                    <div className={classes.stepCard}>
                        <div className={classes.stepNumber}>3</div>
                        <div className={classes.stepIcon}>
                            <FaChartLine size={32} />
                        </div>
                        <div className={classes.stepContent}>
                            <Heading xl5 primitive950 className={classes.stepTitle}>
                                Watch Your Portfolio Grow
                            </Heading>
                            <Text primitive800 lg className={classes.stepText}>
                                Monitor your investments through your dashboard and track your portfolio's growth over time.
                            </Text>
                        </div>
                    </div>
                </div>

                {/* Additional Features Section */}
                <div className={classes.featuresContainer}>
                    {/* Security Section */}
                    <div className={classes.featureCard}>
                        <div className={classes.featureIcon}>
                            <FaShieldAlt size={32} />
                        </div>
                        <div className={classes.featureContent}>
                            <Heading xl5 primitive950 className={classes.featureTitle}>
                                Secure Platform
                            </Heading>
                            <Text primitive800 lg className={classes.featureText}>
                                Your investments are protected with advanced security measures, including two-factor authentication and encrypted transactions.
                            </Text>
                        </div>
                    </div>

                    {/* Support Section */}
                    <div className={classes.featureCard}>
                        <div className={classes.featureIcon}>
                            <FaHeadset size={32} />
                        </div>
                        <div className={classes.featureContent}>
                            <Heading xl5 primitive950 className={classes.featureTitle}>
                                24/7 Support
                            </Heading>
                            <Text primitive800 lg className={classes.featureText}>
                                Our dedicated support team is available around the clock to assist you with any questions or concerns.
                            </Text>
                        </div>
                    </div>

                    {/* FAQ Section */}
                    <div className={classes.featureCard}>
                        <div className={classes.featureIcon}>
                            <FaUserTie size={32} />
                        </div>
                        <div className={classes.featureContent}>
                            <Heading xl5 primitive950 className={classes.featureTitle}>
                                Dedicated Account Manager
                            </Heading>
                            <Text primitive800 lg className={classes.featureText}>
                                Get personalized guidance from your dedicated account manager who will help you optimize your investment strategy and portfolio growth.
                            </Text>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HowToStartPage;
